<a aria-label="Drawer back link" class="route-navigation-wrap" [routerLink]="[link]">
  <div class="route-navigation-button back-button">
    <mat-icon class="back-icon" aria-label="Drawer back button" svgIcon="arrow_blue_right"></mat-icon>
  </div>
  <span class="route-navigation-text">Back</span>
</a>
